"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _PercentSmiley = _interopRequireDefault(require("./PercentSmiley"));
var _ShowValue = _interopRequireDefault(require("./ShowValue"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Callout = function Callout(props) {
  var _props$settings = props.settings,
    title = _props$settings.title,
    description = _props$settings.description,
    colors = _props$settings.colors;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper,
    style: colors ? {
      border: "1px solid ".concat(colors.primary)
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].title,
    style: colors ? {
      backgroundColor: colors.primary
    } : {}
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].description,
    style: description ? {
      padding: '0.5em'
    } : {}
  }, description), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].component
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.BrowserOnly, null, /*#__PURE__*/_react["default"].createElement(_PercentSmiley["default"], {
    data: props.data,
    colors: colors
  })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.PrintOnly, null, /*#__PURE__*/_react["default"].createElement(_ShowValue["default"], {
    data: props.data.value,
    colors: colors
  }))));
};
Callout.propTypes = {
  settings: _propTypes["default"].object,
  handle: _propTypes["default"].string,
  data: _propTypes["default"].object
};
Callout.defaultProps = {};
var _default = exports["default"] = Callout;